/* eslint-disable no-constant-condition */
import { useState, useEffect } from "react";
import { Grid, Switch, FormControlLabel, Tooltip, Checkbox } from "@mui/material";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import { httprequest } from "../../../../data/api";
import Button from "../../../../components/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useValidator from "../../../../hooks/useValidator";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import useStyles from "../../styles";
import { useUserState } from "../../../../context/UserContext";
import Select from "react-select";
import { Icon } from "@iconify/react";
import WidgetTitle from "../../../dashboard/components/WidgetTitle/WidgetTitle";
import { formatTimeForApi, isExamEndAfterStart, getScheduleWindowMinutes } from "../../../../utils/examScheduleDatetime";

const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const TEACHER_SUBJECT_FOR_CLASS_ENDPOINT = "/api/v1/teacher/class-subject/";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
// const ADMIN_SUBJECT_ENDPOINT = "/api/v1/subjects";
const EXAM_CONFIG_ENDPOINT = "/api/v1/examination-configs";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const SESSION_ENDPOINT = "/api/v1/school-plan/session";

const CreateExam = () => {
  // const [file, setFile] = useState();
  // const [select, setSelect] = useState("");
  const styles = useStyles();
  const { userRole } = useUserState();
  const navigate = useNavigate();
  const [classData, setClassData] = useState([]);
  // const [subjectData, setSubjectData] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  // eslint-disable-next-line no-unused-vars -- used in Save as Draft button isLoading and onClick
  const [isDrafting, setIsDrafting] = useState(false);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [createExamValidator, showCreateExamValidator] = useValidator();
  const [activeSession, setActiveSession] = useState({});
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [aSession, setASession] = useState("");
  const [allTerm, setAllTerms] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const isTeacher = userRole?.role_type === "employee";

  const [schoolExaminationForm, setSchoolExamForm] = useState({
    subject_id: "",
    session_id: "",
    term_id: "",
    title: "",
    class_id: [],
    description: "",
    total_grade: 0,
    instruction: "",
    duration: 0,
    grade_level: "",
    time_per_question: "",
    exam_date: "",
    start_time: "",
    end_time: "",
    random_question: "no",
    random_options: "no",
    display_score_after_exam: "no",
    question_display_mode: "",
    questions_per_page: "",
    proctoring_requirements: "",
    browser_lockdown: false,
    is_private: false,
    use_exam_schedule: true,
    questions: []
  });

  /**
 * Fetches all available academic sessions from the backend.
 * Updates the sessionData state with the fetched data.
 */
  const getAllSession = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        setSessionData(res?.data?.data);
        setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
      })
      .catch(() => {});
  };

  /**
 * Fetches all terms from the backend and filters by session ID.
 * @param {string} Session_id - The ID of the selected session.
 */
  const getAllTerms = (Session_id) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setAllTerms(res?.data?.data.filter((session_term) => session_term?.session_id === Session_id));
        // setActiveTerm(
        //   res?.data?.data.filter(
        //     (active_term) => active_term?.is_current === true
        //   )
        // );
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session dropdown change and fetches terms for selected session.
 * @param {event parameter passed on handleEditSessionChange} e - Change event from session dropdown.
 */
  const handleEditSessionChange = (e) => {
    const { value } = e.target;
    setASession(value);
    setASelectedTerm("");
    setSchoolExamForm((prev) => ({ ...prev, session_id: value || "", term_id: "" }));
    getAllTerms(value);
  };

  /**
 * Handles change to assignment input fields (e.g., title, instruction).
 * @param {event parameter passed on handleAssignmentChange} e
 */
  const handleAssignmentChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updates = { ...schoolExaminationForm, [name]: type === "checkbox" ? checked : value };
    if (name === "use_exam_schedule" && checked) {
      updates.exam_date = "";
      updates.start_time = "";
      updates.end_time = "";
    }
    setSchoolExamForm(updates);
  };

  /**
   * Builds the examination config payload for the API.
   */
  const buildExamConfigPayload = () => {
    const classIds = (schoolExaminationForm?.class_id || []).map((c) => c?.id).filter(Boolean);
    const durationNum = Number(schoolExaminationForm.duration);
    const questionsDisplayMode = schoolExaminationForm.question_display_mode === "one"
      ? "one_per_page"
      : "all_at_once";

    const useSchedule = !!schoolExaminationForm.use_exam_schedule;

    return {
      subject_id: schoolExaminationForm.subject_id,
      session_id: schoolExaminationForm.session_id,
      term_id: schoolExaminationForm.term_id,
      class_id: classIds,
      title: schoolExaminationForm.title,
      description: schoolExaminationForm.description || "",
      instructions: schoolExaminationForm.instruction || "",
      duration: Number.isNaN(durationNum) ? 0 : durationNum,
      randomize_questions: schoolExaminationForm.random_question === "yes",
      randomize_options: schoolExaminationForm.random_options === "yes",
      questions_display_mode: questionsDisplayMode,
      display_score_after_exam: schoolExaminationForm.display_score_after_exam === "yes",
      is_private: !!schoolExaminationForm.is_private,
      use_exam_schedule: useSchedule,
      start_date: useSchedule ? null : (schoolExaminationForm.exam_date || null),
      start_time: useSchedule ? null : formatTimeForApi(schoolExaminationForm.start_time),
      end_time: useSchedule ? null : formatTimeForApi(schoolExaminationForm.end_time)
    };
  };

  const isDurationValid = () => {
    const d = schoolExaminationForm.duration;
    if (d === "" || d === null || typeof d === "undefined") {
      return false;
    }
    const num = Number(d);

    return !Number.isNaN(num) && num > 0;
  };

  /**
   * Creates exam config (published).
   */
  const handleCreateExam = () => {
    if (!isDurationValid()) {
      showCreateExamValidator(true);
      toast.error("Exam duration is required and must be a positive number (minutes).");

      return;
    }
    if (!schoolExaminationForm.use_exam_schedule) {
      const hasDateTime = schoolExaminationForm.exam_date
        && schoolExaminationForm.start_time
        && schoolExaminationForm.end_time;
      if (!hasDateTime) {
        showCreateExamValidator(true);
        toast.error("Exam date, start time, and end time are required when Use Exam Schedule is off.");

        return;
      }
      if (!isExamEndAfterStart(
        schoolExaminationForm.exam_date,
        schoolExaminationForm.start_time,
        schoolExaminationForm.end_time
      )) {
        toast.error("Start time must be before end time.");

        return;
      }
    }
    if (createExamValidator.allValid()) {
      setIsCreating(true);
      const payload = buildExamConfigPayload();
      httprequest
        .post(EXAM_CONFIG_ENDPOINT, payload)
        .then((res) => {
          setIsCreating(false);
          toast.success(res?.data?.message ?? "Examination config created successfully.");
          const data = res?.data?.data;
          const examId = data?.id ?? res?.data?.id ?? null;
          if (examId) {
            navigate(`/school-examination/examination-details/${examId}`);
          } else {
            navigate(isTeacher ? "/examinations" : "/school-examination/examination");
          }
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to create examination config.");
        });
    } else {
      showCreateExamValidator(true);
    }
  };

  /**
   * Creates exam config (draft). Used by Save as Draft button.
   */
  // eslint-disable-next-line no-unused-vars -- used in Save as Draft button onClick
  const handleCreateDraftExam = () => {
    if (!isDurationValid()) {
      showCreateExamValidator(true);
      toast.error("Exam duration is required and must be a positive number (minutes).");

      return;
    }
    if (!schoolExaminationForm.use_exam_schedule) {
      const hasDateTime = schoolExaminationForm.exam_date
        && schoolExaminationForm.start_time
        && schoolExaminationForm.end_time;
      if (!hasDateTime) {
        showCreateExamValidator(true);
        toast.error("Exam date, start time, and end time are required when Use Exam Schedule is off.");

        return;
      }
      if (!isExamEndAfterStart(
        schoolExaminationForm.exam_date,
        schoolExaminationForm.start_time,
        schoolExaminationForm.end_time
      )) {
        toast.error("Start time must be before end time.");

        return;
      }
    }
    if (createExamValidator.allValid()) {
      setIsDrafting(true);
      const payload = buildExamConfigPayload();
      httprequest
        .post(EXAM_CONFIG_ENDPOINT, payload)
        .then((res) => {
          setIsDrafting(false);
          toast.success(res?.data?.message ?? "Examination config saved as draft.");
          const draftData = res?.data?.data;
          const examId = draftData?.id ?? res?.data?.id ?? null;
          if (examId) {
            navigate(`/school-examination/examination-details/${examId}`);
          } else {
            navigate(isTeacher ? "/examinations" : "/school-examination/examination");
          }
        })
        .catch((err) => {
          setIsDrafting(false);
          toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to save examination config.");
        });
    } else {
      showCreateExamValidator(true);
    }
  };

  // const handleCreateExam = () => {
  //   handlePostAssignment("published");
  // };
  /**
 * Handles click on additional menu icon for question.
 * @param {React.MouseEvent} event
 * @param {number} queInd - Index of the question.
 */
  /**
 * Fetches all classes for the current user depending on their role (teacher or admin),
 * and updates the `classData` state with the result.
 */
  const getAllTeacherClasses = () => {
    httprequest
      .get(TEACHER_CLASS_ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data.map((clss) => {
          return {
            class_name: clss?.class?.name,
            id: clss?.class?.id
          };
        }));
      })
      .catch(() => {});
  };

  /**
   * Get all classes as a school admin
   */
  const getAllAdminClasses = () => {
    const ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : ADMIN_CLASS_ENDPOINT;
    httprequest
      .get(ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data);
      }).catch(() => {});
  };

  /**
 * Fetches all subjects for a selected class, depending on the user role (teacher or admin),
 * and updates the `allClassSubject` state with the result.
 *
 * @param {string} classValue - The ID or value of the selected class.
 */
  const getSubjectsForClasses = async (classValues) => {
    try {
      if (!classValues || classValues.length === 0) {
        setAllClassSubject([]);
        setSchoolExamForm((prev) => ({ ...prev, subject_id: "" }));

        return;
      }

      let intersectedSubjects = null;

      // Loop through each selected class to fetch subjects
      for (const { id: classId } of classValues) {
        const SUBJECT_ENDPOINT = isTeacher ? TEACHER_SUBJECT_FOR_CLASS_ENDPOINT : CLASS_SUBJECT;
        const res = await httprequest.get(`${SUBJECT_ENDPOINT}${classId}`);
        const classSubjects = res?.data?.data || [];

        const normalized = classSubjects.map((sub) => {
          if (isTeacher) {
            return {
              subject_id: sub?.subject?.id,
              subject: sub?.subject,
              displayName: sub?.subject?.name
            };
          }

          return {
            subject_id: sub?.subject_id,
            subject_name: sub?.subject_name,
            displayName: sub?.subject_name
          };
        });

        if (intersectedSubjects === null) {
          intersectedSubjects = normalized;
        } else {
          intersectedSubjects = intersectedSubjects.filter((existing) => normalized.some((newSub) => newSub.subject_id === existing.subject_id));
        }
      }

      const finalSubjects = intersectedSubjects || [];
      // Update state with the accumulated unique subjects
      setAllClassSubject(finalSubjects);

      // If the currently selected subject is not in the new intersected list, clear it
      setSchoolExamForm((prev) => {
        if (prev.subject_id && !finalSubjects.some((s) => s.subject_id === prev.subject_id)) {
          return { ...prev, subject_id: "" };
        }

        return prev;
      });
    } catch (err) {
      toast.error(err?.response?.data);
    }
  };

  /**
   * Handle Class Change and Get Subject for their respective Classes
   */
  const handleMultipleAccessChange = async (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => ({
      id: option?.id ?? option?.class?.id,
      name: option?.class_name ?? option?.name ?? option?.class?.name
    }));

    // Update selected class IDs in state
    setSchoolExamForm((prevForm) => ({
      ...prevForm,
      class_id: selectedValues
    }));

    // Fetch and update subjects for all selected classes
    getSubjectsForClasses(selectedValues);
  };

  useEffect(() => {
    if (activeSession?.id) {
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
      setSchoolExamForm((prev) => ({ ...prev, term_id: active_term_session?.id }));
    }
  }, [active_term_session]);

  // Default session_id and term_id on load when active session/term are available
  useEffect(() => {
    if (activeSession?.id) {
      setASession(activeSession?.id);
      setSchoolExamForm((prev) => ({ ...prev, session_id: activeSession?.id }));
    }
  }, [activeSession?.id]);

  /**
   * Handle Term Change and update the school examination form state.
   * @param {event parameter passed on handleTermChange} event - The change event from the term dropdown.
   */
  const handleTermChange = (event) => {
    const { name, value } = event.target;
    setASelectedTerm(value);
    setSchoolExamForm({ ...schoolExaminationForm, [name]: value });
  };

  useEffect(() => {
    if (userRole?.role === "school_admin") {
      getAllAdminClasses();
      getAllTerms();
      getAllSession();
      // getAllAdminSubjects();
    } else {
      getAllTeacherClasses();
      getAllSession();
      getAllTerms();
      // getAllTeacherSAubjects();
    }
  }, []);

  const scheduleWindowMins = getScheduleWindowMinutes(
    schoolExaminationForm.start_time,
    schoolExaminationForm.end_time
  );
  const scheduleTimesOrderOk = isExamEndAfterStart(
    schoolExaminationForm.exam_date,
    schoolExaminationForm.start_time,
    schoolExaminationForm.end_time
  );

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            {isTeacher ? (
              <div>
                <BreadCrumb
                  link_one="/examinations"
                  link_one_name="All Examinations"
                  active="Create Examination"
                  description="Create a new examination"
                />
              </div>
            ) : (
              <div>
                <BreadCrumb
                  link_one="/school-examination/examination"
                  link_one_name="All Examinations"
                  active="Create Examination"
                  description="Create a new examination"
                />
              </div>
            )}
          </div>
          <div className="page-content">
            <div className={styles.assignmentcontainerform}>
              <WidgetTitle title="Exam Metadata" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      inputType="text"
                      inputName="title"
                      onChange={handleAssignmentChange}
                      required
                    />
                    {createExamValidator.message(
                      "title",
                      schoolExaminationForm?.title,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p>Class</p>
                      <Select
                        isMulti
                        name="class_id"
                        closeMenuOnSelect={false}
                        options={classData}
                        onChange={handleMultipleAccessChange}
                        getOptionLabel={(option) => option.class_name ?? option.name ?? option.class?.name ?? ""}
                        getOptionValue={(option) => option.id ?? option.class?.id ?? ""}
                      />
                    </div>
                    {createExamValidator.message(
                      "class_id",
                      schoolExaminationForm?.class_id,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Subjects"
                      required
                      children={
                        <select name="subject_id" onChange={handleAssignmentChange}>
                          <option value="">--- Select ---</option>
                          {allClassSubject?.map((sub) => (
                            <option
                              key={sub?.subject?.id || sub?.subject_id}
                              value={sub?.subject?.id || sub?.subject_id}
                            >
                              {sub?.displayName}
                            </option>
                          ))}
                        </select>
                      }
                    />
                    {createExamValidator.message(
                      "subject_id",
                      schoolExaminationForm?.subject_id,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Session"
                      required
                      children={
                        <select value={aSession} onChange={handleEditSessionChange}>
                          <option value="">--- Select ---</option>
                          {sessionData?.map((sesh) => (
                            <option key={sesh?.id} value={sesh?.id}>
                              {sesh?.session}
                            </option>
                          ))}
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Term"
                      required
                      children={
                        <select
                          value={aselectedTerm}
                          name="term_id"
                          onChange={handleTermChange}
                        >
                          <option value="">--- Select ---</option>
                          {allTerm?.map((term) => (
                            <option key={term?.id} value={term?.id}>
                              {term?.term}
                            </option>
                          ))}
                        </select>
                      }
                    />
                    {createExamValidator.message(
                      "term_id",
                      schoolExaminationForm?.term_id,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextAreaGroup
                      label="Description"
                      inputName="description"
                      margin="normal"
                      placeholder=""
                      onChange={handleAssignmentChange}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextAreaGroup
                      label="Examination Instruction"
                      inputName="instruction"
                      margin="normal"
                      placeholder=""
                      onChange={handleAssignmentChange}
                    />
                  </Grid>
                </Grid>
              </div>
              <WidgetTitle title="Time Configuration" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Exam Duration (minutes)"
                      margin="normal"
                      inputType="number"
                      inputName="duration"
                      placeHolder="e.g. 60"
                      value={schoolExaminationForm.duration === 0 ? "" : schoolExaminationForm.duration}
                      onChange={handleAssignmentChange}
                      required
                    />
                    {createExamValidator.message(
                      "duration",
                      isDurationValid() ? schoolExaminationForm.duration : "",
                      "required"
                    )}
                  </Grid>

                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Time per Question (optional)"
                      margin="normal"
                      inputType="number"
                      inputName="time_per_question"
                      placeHolder="e.g. 2"
                      value={schoolExaminationForm.time_per_question === 0 ? "" : schoolExaminationForm.time_per_question}
                      onChange={handleAssignmentChange}
                    />
                  </Grid>
                  {!schoolExaminationForm.use_exam_schedule && (
                    <>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <InputGroup
                          label="Exam Date"
                          margin="normal"
                          inputType="date"
                          inputName="exam_date"
                          value={schoolExaminationForm.exam_date}
                          onChange={handleAssignmentChange}
                          required
                        />
                        {createExamValidator.message(
                          "exam_date",
                          schoolExaminationForm.exam_date,
                          "required"
                        )}
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <InputGroup
                          label="Start Time"
                          margin="normal"
                          inputType="time"
                          inputName="start_time"
                          value={schoolExaminationForm.start_time}
                          onChange={handleAssignmentChange}
                          required
                        />
                        {createExamValidator.message(
                          "start_time",
                          schoolExaminationForm.start_time,
                          "required"
                        )}
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <InputGroup
                          label="End Time"
                          margin="normal"
                          inputType="time"
                          inputName="end_time"
                          value={schoolExaminationForm.end_time}
                          onChange={handleAssignmentChange}
                          required
                        />
                        {createExamValidator.message(
                          "end_time",
                          schoolExaminationForm.end_time,
                          "required"
                        )}
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        {schoolExaminationForm.start_time && schoolExaminationForm.end_time && (
                          <>
                            {!scheduleTimesOrderOk && (
                              <p style={{ color: "#d32f2f", fontSize: 14, margin: "4px 0 0" }}>
                                Start time must be before end time.
                              </p>
                            )}
                            {scheduleTimesOrderOk && scheduleWindowMins != null && (
                              <p style={{ color: "#667185", fontSize: 14, margin: "4px 0 0" }}>
                                Exam window: <strong>{scheduleWindowMins}</strong> minutes
                              </p>
                            )}
                          </>
                        )}
                      </Grid>
                    </>
                  )}
                  <Grid item lg={12} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "flex-start" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="use_exam_schedule"
                          checked={!!schoolExaminationForm.use_exam_schedule}
                          onChange={handleAssignmentChange}
                          color="primary"
                        />
                      }
                      label={
                        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          Use Exam Schedule
                          <Tooltip
                            title="If checked, Exam start date and End date would not be used and this exam will need to be scheduled in exam schedule"
                            arrow
                            placement="top"
                          >
                            <span style={{ display: "inline-flex", cursor: "help" }}>
                              <Icon icon="mdi:help-circle-outline" width={18} height={18} style={{ color: "#667185" }} />
                            </span>
                          </Tooltip>
                        </span>
                      }
                    />
                  </Grid>
                </Grid>
              </div>
              <WidgetTitle title="Behavior Settings" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Random Question"
                      children={
                        <select
                          name="random_question"
                          value={schoolExaminationForm.random_question}
                          onChange={handleAssignmentChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Randomize Options"
                      children={
                        <select
                          name="random_options"
                          value={schoolExaminationForm.random_options}
                          onChange={handleAssignmentChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Display Score after Exam"
                      children={
                        <select
                          name="display_score_after_exam"
                          value={schoolExaminationForm.display_score_after_exam}
                          onChange={handleAssignmentChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Question Display Mode"
                      children={
                        <select
                          name="question_display_mode"
                          value={schoolExaminationForm.question_display_mode}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="all">All at once</option>
                          <option value="one">One per page</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <label className={styles.enterque} style={{ display: "flex", alignItems: "center" }}>
                      <input
                        className="margin-top-5"
                        type="checkbox"
                        name="is_private"
                        checked={!!schoolExaminationForm.is_private}
                        onChange={handleAssignmentChange}
                      />
                      <span style={{ marginLeft: 4, marginRight: 4 }}>Visibility (Private)</span>
                      <Tooltip title="If checked, this exam will only be visible to assigned candidates." placement="top">
                        <Icon icon="mdi:information-outline" style={{ cursor: "pointer", fontSize: 18 }} />
                      </Tooltip>
                    </label>
                  </Grid>
                  {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Number of question per page"
                      margin="normal"
                      inputType="number"
                      inputName="questions_per_page"
                      placeHolder="e.g. 5"
                      onChange={handleAssignmentChange}
                    />
                  </Grid> */}
                </Grid>
              </div>
              <WidgetTitle title="Security Settings" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label={
                        <span style={{ display: "flex", alignItems: "center" }}>
                          Proctoring requirements
                          <Tooltip title="Specifies the security and monitoring measures enforced during the exam (e.g., Basic, Strict)." placement="top">
                            <Icon icon="mdi:information-outline" style={{ cursor: "pointer", fontSize: 18, marginLeft: 4 }} />
                          </Tooltip>
                        </span>
                      }
                      children={
                        <select
                          name="proctoring_requirements"
                          value={schoolExaminationForm.proctoring_requirements}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="none">None</option>
                          <option value="basic">Basic</option>
                          <option value="strict">Strict</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 16 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            name="browser_lockdown"
                            checked={schoolExaminationForm.browser_lockdown}
                            onChange={handleAssignmentChange}
                            color="primary"
                          />
                        }
                        label="Browser Lockdown"
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div className={styles.btnwrapper}>
                {/* <Button
                  variant="primaryoutline"
                  buttonSize="fluid"
                  color="btnfontprimary"
                  isLoading={isDrafting}
                  onClick={handleCreateDraftExam}
                  buttonName="Save as Draft"
                /> */}
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  buttonName="Create Examination"
                  isLoading={isCreating}
                  onClick={handleCreateExam}
                />
              </div>
            </div>
          </div>
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default CreateExam;
